import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireAction, AngularFireList, PathReference } from 'angularfire2/database';
import { ToastyService, ToastOptions, ToastData } from 'ng2-toasty';
import { ToastCommunicationService } from '../toast/toast-communication.service';
import { AudioService } from '../listening/audio.service';
import { IEventoAlarma, IReporteAlarma } from '../../models/alarma.model';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class FirebasedatabaseService {
  rutaAbonados: string;

  idUser: number;

  public eventos: IEventoAlarma[] = [];
  public reportes: IReporteAlarma[] = [];

  public alarmas: Observable<any[]>;

  // private idgrupo = null;
  position = 'bottom-right';

  // totaldesconectado: any; // Variable que muestra la cantidad de abonados desconectados.

  countAbonadosDesc: any; // Variable que muestra la cantidad de abonados desconectados.
  countAlarmas: any; // Variable que muestra la cantidad de alarmas.
  countReportes: any; // Variable que muestra la cantidad de reportes.


  /////////////////////////////////
  firstLoadingAlarma = true; // para saber si cargo por primera vez las Alarmas.
  firstLoadingReporte = true; // para saber si cargo por primera vez los reportes.
  /////////////////////////////////


  desconectados$: Subscription;


  abona$: BehaviorSubject<IAbonados>;
  alarmas$: BehaviorSubject<IAlarmas>;
  reportes$: BehaviorSubject<IReportes>;

  itemsRef: AngularFireList<unknown>;

  // AbonadosRef: AngularFireList<any>;

  monitoreoPathRef: PathReference;
  monitoreoGrupoPathRef: PathReference;



  onOffMonitoreosubject = new Subject<boolean>(); // Variable para desconectar o conectar a un nodo de firebase.

  pruebaMuestra: string;


  constructor(
    private angularFireDatabase: AngularFireDatabase,
    private toastyService: ToastyService,
    private toastCommunicationService: ToastCommunicationService,
    private audioService: AudioService
  ) {
    this.toastCommunicationService.setPosition(this.position);
  }

  subscriptionNodoGrupos(idmonitoreo: number, idusuario: number) {
    this.monitoreoPathRef = `/monitoreo/${idmonitoreo}/grupos`;

    this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/usuarios/${idusuario}/grupo`)
      .stateChanges()
      .subscribe((actions: any) => {
        // console.log(actions.type);
        // console.log(actions.key);
        // console.log(actions.payload.val());
        // console.log(actions.type, actions.payload.val());

        switch (actions.type) {
          case 'child_added':
            if (actions.payload.val()) {

              this.monitoreoGrupoPathRef = `${this.monitoreoPathRef}/${actions.key}`;
              this.pruebaMuestra = this.monitoreoGrupoPathRef;
              const abonadosDesconectados = `${ this.monitoreoPathRef }/${ actions.key }`;
              this.subscriptionCantAboDesconectados( abonadosDesconectados );
              this.subscriptionCantAlarmas( abonadosDesconectados );
              this.subscriptionCantReportes( abonadosDesconectados );

            }
            break;

          case 'child_changed':

            this.onOffMonitoreosubject.next(actions.payload.val());

            if (actions.payload.val()) {

              this.monitoreoGrupoPathRef = `${ this.monitoreoPathRef }/${ actions.key }`;
              const abonadosDesconectados = `${this.monitoreoPathRef}/${actions.key}`;
              this.subscriptionCantAboDesconectados(abonadosDesconectados);
              this.subscriptionCantAlarmas( abonadosDesconectados );
              this.subscriptionCantReportes( abonadosDesconectados );

            } else {

              // this.monitoreoGrupoPathRef = null;
              this.unSubscritionNodosMonitoreo(`${this.monitoreoPathRef}/${actions.key}`);

              this.setIconAudio('icofont-volume-mute');
            }

            break;

          // case 'child_removed':
          //   // this.eliminarEventos( actions.key );
          //   this.unSubscritionNodo(actions.key);
          // break;
        }
      });
  }

  subscriptionCantAboDesconectados( desconectadosPathRef: string ) {
    this.angularFireDatabase.object(`${ desconectadosPathRef }/abonados/desconectados`)
      .snapshotChanges()
      .subscribe(resp => {
        this.countAbonadosDesc = resp.payload.val();
      });
  }

  subscriptionCantAlarmas( desconectadosPathRef: string ) {
    this.angularFireDatabase.object(`${ desconectadosPathRef }/alarmas/countalarmas`)
      .snapshotChanges()
      .subscribe((resp: any) => {

        if (this.firstLoadingAlarma) {
          this.firstLoadingAlarma = false;
          this.countAlarmas = resp.payload.val();

          if (this.countAlarmas > 0) {
            this.setIconAudio('icofont-volume-bar');
          }

        } else {

          if (resp.payload.val() === 0) {
            this.countAlarmas = resp.payload.val();
            this.setIconAudio('icofont-volume-mute');

          } else {
            if (resp.payload.val() > this.countAlarmas) {
              this.newToast('Alarma Activada', ``, 'error');
              this.setIconAudio('icofont-volume-bar');
            }

            this.countAlarmas = resp.payload.val();

          }
        }

      });
  }

  subscriptionCantReportes( desconectadosPathRef: string ) {
    this.angularFireDatabase.object(`${ desconectadosPathRef }/reportes/countreportes`)
      .snapshotChanges()
      .subscribe(resp => {
        // this.countReportes = resp.payload.val();

        if (this.firstLoadingReporte) {
          this.firstLoadingReporte = false;
          this.countReportes = resp.payload.val();
        } else {
            if (resp.payload.val() > this.countReportes) {
              this.newToast('Reporte Activado', ``, 'warning');
            }
            this.countReportes = resp.payload.val();
        }

      });
  }

  subscriptionNodoAbonados1(param: IAbonados, idmonitoreo: string, idgrupo: string): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
    this.abona$ = new BehaviorSubject(param);
    return this.abona$.pipe(
        switchMap((parametros: IAbonados) =>
        this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/abonados/lista`, ref => {
            if (parametros.macabonado) {
              return ref.orderByChild('macabonado').equalTo(parametros.macabonado);
            } else {
              // return ref.orderByChild('monitoreo').startAt(true, parametros.startKey).limitToFirst(parametros.offset + 1);
              if (!parametros.startKey) {
                return ref.orderByKey().limitToFirst(parametros.offset + 1);
              } else {
                return ref.orderByKey().startAt(parametros.startKey).limitToFirst(parametros.offset + 1);
              }
            }
          }).snapshotChanges()
        )
      );
  }

  filtarAbonados(parametros: IAbonados) {
    this.abona$.next(parametros);
  }

  unSubscritionNodosMonitoreo(monitoreoPathRef: string) {

    // this.angularFireDatabase.database.ref(`${monitoreoPathRef}/abonados/desconectados`).off();
    // this.angularFireDatabase.database.ref(`${monitoreoPathRef}/alarmas/countalarmas`).off();
    // this.angularFireDatabase.database.ref(`${monitoreoPathRef}/reportes/countreportes`).off();

    this.angularFireDatabase.database.ref(`${this.pruebaMuestra}/abonados/desconectados`).off();
    this.angularFireDatabase.database.ref(`${this.pruebaMuestra}/alarmas/countalarmas`).off();
    this.angularFireDatabase.database.ref(`${this.pruebaMuestra}/reportes/countreportes`).off();

    // Reinicio las variables de conteo
    this.countAbonadosDesc = null;
    this.countAlarmas = null;
    this.countReportes = null;

    this.firstLoadingAlarma = true;
    this.firstLoadingReporte = true;
  }

  subscriptionNodoAlarmas1(param: IAlarmas, idmonitoreo: string, idgrupo: string): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
    this.alarmas$ = new BehaviorSubject(param);
    return this.alarmas$.pipe(
      switchMap((parametros: IAlarmas) =>
      this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/alarmas/lista`, ref => {
          if (!parametros.startKey) {
            return ref.orderByKey().limitToLast(parametros.offset + 1);
          } else {
            return ref.orderByKey().endAt(parametros.startKey).limitToLast(parametros.offset + 1);
          }
        }).snapshotChanges()
      )
    );
  }

  nextAndBackAlarmas(param: IAlarmas) {
    this.alarmas$.next(param);
  }

  subscriptionNodoReportes(param: IReportes, idmonitoreo: string, idgrupo: string): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
    this.reportes$ = new BehaviorSubject(param);
    return this.reportes$.pipe(
      switchMap((parametros: IReportes) =>
      this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/reportes/lista`, ref => {
          if (!parametros.startKey) {
            return ref.orderByKey().limitToLast(parametros.offset + 1);
          } else {
            return ref.orderByKey().endAt(parametros.startKey).limitToLast(parametros.offset + 1);
          }
        }).snapshotChanges()
      )
    );
  }

  nextAndBackReportes(param: IReportes) {
    this.reportes$.next(param);
  }

  connectFirebase() {
    this.angularFireDatabase.database.goOnline();
  }

  newToast(titulo: string, mensaje: string, type: string) {

    let toastOptions: ToastOptions = {
      title: titulo,
      msg: mensaje,
      showClose: true,
      timeout: 6000,
      theme: 'default',
      // position: this.options.position,
      onAdd: (toast: ToastData) => {
        // console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: function (toast: ToastData) {
        // console.log('Toast ' + toast.id + ' has been removed!');
      }
    };

    switch (type) {
      case 'default': this.toastyService.default(toastOptions); break;
      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }

  setIconAudio(icon: string) {
    this.audioService.setIconAudio(icon);
  }

  // subscriptionNodoAlarmas(idMonitoreo: number, idgrupo: string) {
  //   this.angularFireDatabase.list(`/monitoreo/${ idMonitoreo }/grupos/${ idgrupo }/alarmas/lista`)
  //     .stateChanges()
  //     .subscribe(actions => {
  //       // console.log(actions.type);
  //       // console.log(actions.key);
  //       // console.log(actions.payload.val());
  //       // console.log('idgrupo ===>>', idgrupo);


  //       switch (actions.type) {
  //         case 'child_added':
  //           let eventoAlarma: IEventoAlarma = actions.payload.val();
  //           eventoAlarma.idgrupo = Number(idgrupo);
  //           eventoAlarma.reporte = eventoAlarma.reporte.replace('_', ' ');
  //           eventoAlarma.nombrecliente = eventoAlarma.nombrecliente.toUpperCase();
  //           this.eventos.unshift(eventoAlarma);
  //           this.newToast(eventoAlarma.reporte, `Cliente: ${eventoAlarma.nombrecliente}`, 'error');
  //           this.setIconAudio('icofont-volume-bar');
  //           break;

  //         case 'child_changed':
  //           break;
  //         case 'child_removed':
  //           // SE ELIMINO EL EVENTO.
  //           // console.log(actions.type);
  //           // console.log(actions.key);
  //           this.removeEvento(actions.key);
  //           break;
  //       }

  //     });
  // }

  // subscriptionNodoAlarmas(idMonitoreo: number, idgrupo: string) {
  //   let a = this.angularFireDatabase.list(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/alarmas/lista`)
  //     .snapshotChanges(['child_added', 'child_changed', 'child_removed']);
  //   a.subscribe(r => {
  //     // console.log(r);
  //   });
  // }


  // subscriptionNodoAlarmas1(param: IAlarmas): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
  //   console.log(this.monitoreoGrupoPathRef);
  //   this.alarmas$ = new BehaviorSubject(param);
  //   return this.alarmas$.pipe(
  //     switchMap((parametros: IAlarmas) =>
  //     this.angularFireDatabase.list(`${ this.monitoreoGrupoPathRef }/alarmas/lista`, ref => {
  //         if (!parametros.startKey) {
  //           return ref.orderByKey().limitToLast(parametros.offset + 1);
  //         } else {
  //           return ref.orderByKey().endAt(parametros.startKey).limitToLast(parametros.offset + 1);
  //         }
  //       }).snapshotChanges()
  //     )
  //   );
  // }





// ['child_added', 'child_changed', 'child_removed', 'child_moved']

  //  subscriptionNodoAlarmas1(param: IAlarmas): any {
  //   return this.angularFireDatabase.list(`/monitoreo/1/grupos/1/alarmas/lista`, ref => {
  //     // if (!param.startKey) {
  //       return ref.orderByKey().limitToLast(param.offset + 1);
  //     // } else {
  //     //   return ref.orderByKey().endAt(param.startKey).limitToLast(param.offset + 1);
  //     // }

  //   }).snapshotChanges();
  // }

  // addOperadorAlarma(key: string, idmonitoreo: string, idgrupo: string, operadorid: number, operador: string) {
  //   this.itemsRef = this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/alarmas/lista`);
  //   this.itemsRef.update( key, { operador: operador, operadorid: operadorid });
  // }

  // deleteOperadorAlarma( key: string, idmonitoreo: string, idgrupo: string ) {
  //   this.itemsRef = this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/alarmas/lista`);
  //   this.itemsRef.update( key, { operador: null, operadorid: null });
  // }


  // subscriptionNodoAlarmas(idMonitoreo: number, idgrupo: string) {
  //   this.alarmas = this.angularFireDatabase.list(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/alarmas/lista`).valueChanges();
  // }

  // subscriptionNodoReportes(idMonitoreo: number, idgrupo: string) {
  //   this.angularFireDatabase.list(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/reportes/lista`)
  //     .stateChanges()
  //     .subscribe(actions => {
  //       // console.log(actions.type);
  //       // console.log(actions.key);
  //       // console.log(actions.payload.val());
  //       // console.log('idgrupo ===>>', idgrupo);

  //       switch (actions.type) {
  //         case 'child_added':
  //           let reporteAlarma: IReporteAlarma = actions.payload.val();
  //           reporteAlarma.idgrupo = Number(idgrupo);
  //           reporteAlarma.reporte = reporteAlarma.reporte.replace('_', ' ');
  //           reporteAlarma.nombrecliente = reporteAlarma.nombrecliente.toUpperCase();
  //           this.reportes.unshift(reporteAlarma);
  //           this.newToast(reporteAlarma.reporte, `Cliente: ${reporteAlarma.nombrecliente}`, 'warning');

  //           // this.reportes.unshift(actions.payload.val());
  //           // let eventoFalla: EventosFalla = actions.payload.val();
  //           // this.newToast(eventoFalla.c_reporte, `Cliente: ${ eventoFalla.c_cliente }`, 'warning');
  //           break;

  //         case 'child_changed':
  //           break;
  //         case 'child_removed':
  //           // SE ELIMINO EL REPORTE.
  //           // console.log(actions.type);
  //           // console.log(actions.key);
  //           this.removerReporte(actions.key);
  //           break;
  //       }

  //     });
  // }

  // subscriptionCantAboDesconectados(idMonitoreo: number, idgrupo: string) {
  //   this.desconectados$ = this.angularFireDatabase.object(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/abonados/desconectados`)
  //     .snapshotChanges()
  //     .subscribe(resp => {
  //       // console.log(resp.type);
  //       // console.log(resp.key);
  //       // console.log(resp.payload.val());
  //       this.totaldesconectado = resp.payload.val();
  //     });
  // }

  // subscriptionNodoAbonados(param: IAbonados): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
  //   this.abona$ = new BehaviorSubject(param);
  //   return this.abona$.pipe(
  //     switchMap((parametros: IAbonados) =>
  //       this.angularFireDatabase.list(`${ this.rutaAbonados }/lista`, ref => {
  //         if (parametros.macabonado) {
  //           return ref.orderByChild('macabonado').equalTo(parametros.macabonado);

  //         } else {
  //           return ref.orderByChild('monitoreo').startAt(true, parametros.startKey).limitToFirst(parametros.offset + 1);
  //         }
  //       }).snapshotChanges()
  //     )
  //   );
  // }




  // subscriptionNodoAbonados1(param: IAbonados, idmonitoreo: string, idgrupo: string): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
  // this.abona$ = new BehaviorSubject(param);
  // return this.abona$.pipe(
  //     switchMap((parametros: IAbonados) =>
  //     this.angularFireDatabase.list(`/monitoreo/${idmonitoreo}/grupos/${idgrupo}/abonados/lista`, ref => {
  //         if (parametros.macabonado) {
  //           return ref.orderByChild('macabonado').equalTo(parametros.macabonado);
  //         }
  //         else {
  //           return ref.orderByChild('monitoreo').startAt(true, parametros.startKey).limitToFirst(parametros.offset + 1);
  //         }
  //       }).snapshotChanges()
  //     )
  //   );
  // }
  // subscriptionNodoAbonados(param: IAbonados): Observable<AngularFireAction<firebase.database.DataSnapshot>[]> {
  //   this.abona$ = new BehaviorSubject(param);
  //   return this.abona$.pipe(
  //     switchMap((parametros: IAbonados) =>
  //       this.angularFireDatabase.list(`${ this.monitoreoGrupoPathRef }/abonados/lista`, ref => {
  //         if (parametros.macabonado) {
  //           return ref.orderByChild('macabonado').equalTo(parametros.macabonado);
  //         } else {
  //           return ref.orderByChild('monitoreo').startAt(true, parametros.startKey).limitToFirst(parametros.offset + 1);
  //         }
  //       }).snapshotChanges()
  //     )
  //   );
  // }

  // unSubscritionNodoEventos(idMonitoreo: number, idgrupo: string) {
  //   this.angularFireDatabase.database.ref(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/alarmas/lista`).off();
  // }

  // unSubscritionNodoReportes(idMonitoreo: number, idgrupo: string) {
  //   this.angularFireDatabase.database.ref(`/monitoreo/${idMonitoreo}/grupos/${idgrupo}/reportes/lista`).off();
  // }

  // unSubscriptionCantAboDesconectados() {
  //   this.desconectados$.unsubscribe();
  //   this.totaldesconectado = null;
  // }

  // unSubscriptionCantAboDesconectados() {
  //   this.totaldesconectado = null;
  // }

  // removeEvento(idevento) {
  //   idevento = Number(idevento);
  //   this.eventos.forEach((evento, index, object) => {
  //     if (evento.idabonadoalarma === idevento) {
  //       object.splice(index, 1);
  //       return;
  //     }
  //   });

  //   if (this.eventos.length === 0) {
  //     this.setIconAudio('icofont-volume-mute');
  //   }
  // }

  // removerReporte(idreporte) {
  //   idreporte = Number(idreporte);
  //   this.reportes.forEach((evento, index, object) => {
  //     if (evento.idabonadoreporte === idreporte) {
  //       object.splice(index, 1);
  //       return;
  //     }
  //   });
  // }

  // disconnectFirebase(idMonitoreo: number, idUsuario: number) {

  //   this.angularFireDatabase.database.ref(`/monitoreo/${idMonitoreo}/usuarios/${idUsuario}/grupo`).off();

  //   if (this.idgrupo) {
  //     this.angularFireDatabase.database.ref(`/monitoreo/${idMonitoreo}/grupos/${this.idgrupo}/eventos`).off();
  //     this.angularFireDatabase.database.ref(`/monitoreo/${idMonitoreo}/grupos/${this.idgrupo}/reportes`).off();
  //   }

  //   this.angularFireDatabase.database.goOffline();
  //   this.eventos = [];
  //   this.reportes = [];

  //   this.firstLoadingAlarma = true;
  //   this.firstLoadingReporte = true;
  // }
}



export interface IAbonados {
  offset?: number;
  startKey?: string;
  macabonado?: string;
}

export interface IAlarmas {
  offset?: number;
  startKey?: string;
}

export interface IReportes {
  offset?: number;
  startKey?: string;
}

//  TIPOS DE EVENTOS ( CRUD ) AND ( SUBSCRIPCION )
//  child_added     ==>   CUANDO SE SUBSCRIBE A UN NODO.
//  child_added     ==>   CUANDO SE AGREGA UN FILA.
//  child_changed   ==>   CUANDO SE HACE UN CAMBIO DATO DE UNA FILA.
//  child_changed   ==>   CUANDO ELIMINO UNA COLUMNA DE UNA LA FILA.
//  child_removed   ==>   CUANDO SE ELIMINA UNA FILA.


/*
  valueChanges()    ==>
  stateChanges()    ==> Trae la data uno por uno
  snapshotChanges() ==> trae la data en una lista

*/
